import { render, staticRenderFns } from "./ChatGroupPushFooter.vue?vue&type=template&id=7ffff4a7&scoped=true&lang=pug&"
import script from "./ChatGroupPushFooter.vue?vue&type=script&lang=js&"
export * from "./ChatGroupPushFooter.vue?vue&type=script&lang=js&"
import style0 from "./ChatGroupPushFooter.vue?vue&type=style&index=0&id=7ffff4a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffff4a7",
  null
  
)

export default component.exports